import { useCallback } from "react";
import { useAPIAction, UserAccountApi } from "melco-shared-logic";

export const useDeleteAPIKeys = () => {
  const [deleteAPIKey] = useAPIAction(
    UserAccountApi,
    async (api, id: string) => {
      const data = await api.accountApiKeysDelete({ id });

      return {
        successMessages: [{ message: "default" }],
        data,
      };
    },
    {
      translationPrefix: "api_list.actions.delete",
    }
  );

  return useCallback(
    async (apiKeyIds: string[]) => {
      const successfullyDeleted: string[] = [];

      for (const apiKeyId of apiKeyIds) {
        try {
          await deleteAPIKey(apiKeyId);
          successfullyDeleted.push(apiKeyId);
        } catch (e) {
          // error handling is already done in useAPIAction
        }
      }

      return successfullyDeleted;
    },
    [deleteAPIKey]
  );
};
